import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TrocarClienteComponent } from './trocar-cliente.component';

@Injectable({ providedIn: 'root' })
export class TrocarClienteService {
  private readonly dialog = inject(MatDialog);
  private readonly router = inject(Router);

  abrir(): void {
    const dialogRef = this.dialog.open(TrocarClienteComponent, {
      data: { data: {}, action: 'Trocar Cliente' },
      disableClose: true,
      panelClass: 'dialog-rounded',
      width: '1080px',
      maxWidth: '95vw',
      maxHeight: '100vh'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        this.recarregarRotaAtual();
      }
    });
  }

  private recarregarRotaAtual(): void {
    const currentUrl = this.router.url;

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(currentUrl);
    });
  }
}
